export default {
  title: 'My documents',
  badgeType: 'Documents',
  description: {
    part1: 'Several',
    part2: 'documents are available in electronic format',
    part3: 'and others will be added as they become available in electronic format.',
    ariaLabel: 'view available documents.',
    ariaPLabel: 'view available documents in electronic format.',
  },
  documentsTile: {
    title: 'My documents',
    text: 'All official documents, such as statements or tax documents, are grouped together in one place.',
    link: 'View my documents',
  },
  modalTitle: 'Documents available in electronic format',
  download: 'Download',
  search: 'Search',
  reset: 'Reset',
  keyword: 'Keyword',
  period: 'Period',
  periodAll: 'All',
  type: 'Type',
  product: 'Product',
  noDocuments: 'No document',
  noResults: {
    title: 'No documents found',
    description: 'We did not find any document corresponding to your search.',
    suggestions: 'Suggestions :',
    suggestion1: 'Check the spelling of the search terms.',
    suggestion2: 'Use more general keywords.',
    suggestion3: 'Specify fewer search criteria.',
  },
};
